module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/Daoan/uparrow.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FDaoan%2Fuparrow.png
// module id = Cg4V
// module chunks = 93